// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1Hkhs","productName":"Table_productName__3jdMR"};